import BadgeActionList from '@/components/BadgeActionList/BadgeActionList';
import BadgeDetailHeader from '@/components/BadgeDetailHeader/BadgeDetailHeader';
import BadgeOtherBadges from '@/components/BadgeOtherBadges/BadgeOtherBadges';
import {BadgeRewardsList} from '@/components/BadgeRewardsList/BadgeRewardsList';
import {BADGE_STATUSES} from '@/consts/loyalty/badgeStatuses';
import {useSingleLevelNotification} from '@/hooks/useJourneyNotification';
import {getBadgeDetailsContent} from '@/services/content/appContent';
import type {PluralFormsModel} from '@/types/aem';
import type {Badge} from '@/types/loyalty';

type SingleLevelBadgeDetailsProps = {
    badge: Badge;
    titleId?: string;
    showProgress?: boolean;
    hideOtherBadges?: boolean;
    onBack?: () => void;
    selectRewardPluralForms?: PluralFormsModel | null;
};

const SingleLevelBadgeDetails = ({
    badge,
    titleId,
    showProgress = false,
    hideOtherBadges = false,
    onBack,
    selectRewardPluralForms,
}: SingleLevelBadgeDetailsProps) => {
    const {title, imageUrl, status, actions, totalSteps, finishedSteps, rewards, journeyId} = badge;
    const isEarned = status === BADGE_STATUSES.COMPLETED;

    const notification = useSingleLevelNotification(badge);

    const {singleLevelBadgeDetailsContent} = getBadgeDetailsContent();
    const {
        badgeBackgroundImage,
        remainingStepsPluralForms,
        selectRewardPluralForms: contentSelectRewardPluralForms,
        rewardDetailExternalLink,
    } = singleLevelBadgeDetailsContent ?? {};

    const rewardPluralForms = selectRewardPluralForms ?? contentSelectRewardPluralForms;

    return (
        <div className='flex flex-col gap-8 pb-app-4'>
            <BadgeDetailHeader
                title={title}
                titleId={titleId}
                imageUrl={imageUrl}
                backgroundImage={badgeBackgroundImage}
                notification={notification}
                isEarned={isEarned}
                badge={badge}
                totalSteps={showProgress ? totalSteps : undefined}
                finishedSteps={showProgress ? finishedSteps : undefined}
                remainingStepsPluralForms={showProgress ? remainingStepsPluralForms : undefined}
                onBack={onBack}
            />
            <BadgeActionList actions={actions} />
            {rewards && rewards.length > 0 && (
                <BadgeRewardsList
                    rewards={rewards}
                    journeyId={journeyId}
                    selectRewardPluralForms={rewardPluralForms}
                    rewardDetailExternalLink={rewardDetailExternalLink}
                />
            )}
            {!hideOtherBadges && <BadgeOtherBadges currentBadgeId={badge.id} />}
        </div>
    );
};

export default SingleLevelBadgeDetails;
